import styled from 'styled-components';
import InvalidNameSvg from '../../assets/mytrips/invalid-name.svg';

const InvalidNameIcon = styled(InvalidNameSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.7rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default InvalidNameIcon;
